if (!customElements.get('oshe-quick-add')) {
  customElements.define(
    'oshe-quick-add',
    class OsheQuickAdd extends HTMLElement {
      constructor() {
        super();
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.onPointerDown = this.onPointerDown.bind(this);
        this.onClick = this.onClick.bind(this);
        this.addEventListener('pointerdown', this.onPointerDown, true);
        this.addEventListener('click', this.onClick, true);
      }

      stopCardLink(event) {
        event.preventDefault();
        event.stopPropagation();
      }

      onPointerDown(event) {
        this.stopCardLink(event);
      }

      onClick(event) {
        this.stopCardLink(event);

        const button = event.target.closest('[data-variant-id]');
        if (!button || button.disabled) return;
        if (button.getAttribute('aria-disabled') === 'true') return;

        this.addToCart(button);
      }

      addToCart(button) {
        const variantId = button.dataset.variantId;
        this.querySelectorAll('[data-variant-id]').forEach((el) => el.classList.remove('is-selected'));
        button.classList.add('is-selected');
        button.setAttribute('aria-disabled', 'true');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', variantId);
        formData.append('quantity', 1);

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;

        fetch(`${window.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'oshe-quick-add',
                productVariantId: variantId,
                errors: response.errors || response.description,
                message: response.message,
              });
              return;
            }

            if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'oshe-quick-add',
              productVariantId: variantId,
              cartData: response,
            });
            this.cart.renderContents(response);
            if (this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
          })
          .catch((error) => {
            console.error(error);
          })
          .finally(() => {
            button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
